'use strict';

angular.module('myConsultApp')
    .factory('AutoPilotService', function ($resource, ENV, Session) {

        var autoPilotService = {};

        autoPilotService.getDefaultSettings = function() {
            var defaults = $resource(ENV.apiEndpoint + '/1.0/apps/autopilot/risks/',{},{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});

            return defaults.get().$promise.then(function(response) {
                return response;
            });
        };

        autoPilotService.getSettings = function (orgId) {
            var setting = $resource(ENV.apiEndpoint + '/1.0/apps/autopilot/organization/:orgId/',{ orgId : orgId },{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});
            
            return setting.get().$promise.then(function(response) {
                return response;
            });
        };

        autoPilotService.saveSettings = function (orgId, data) {

            var setting = $resource(ENV.apiEndpoint + '/1.0/apps/autopilot/organization/:orgId/',{ orgId : orgId }, {
                save:{
                    method: 'PUT',
                    headers: { 'Authorization': 'Bearer '+Session.accessToken }
                }
            });

            return setting.save(data).$promise.then(function(response) {
                return response;
            });
        };

        autoPilotService.getSurveySettings = function (surveyId) {
            var setting = $resource(ENV.apiEndpoint + '/1.0/apps/autopilot/survey/:surveyId/',{ surveyId : surveyId },{get:{headers: { 'Authorization': 'Bearer '+Session.accessToken }}});
            
            return setting.get().$promise.then(function(response) {
                return response;
            });
        };

        return autoPilotService;
  });